import type { ReactNode } from 'react';
import type { IconName } from '@/content/icons';
import { Icon } from './Icon';

export type BadgeTone = 'neutral' | 'outline' | 'solid' | 'quiet' | 'tint';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-surface-2 text-fg border-transparent',
  outline: 'bg-transparent text-fg-muted border-line-strong',
  solid: 'badge-solid border-transparent',
  quiet: 'bg-surface-1 text-fg-subtle border-line',
  tint: 'badge-tint border-transparent',
};

export function Badge({
  children,
  tone = 'neutral',
  icon,
  className,
}: {
  children: ReactNode;
  tone?: BadgeTone;
  icon?: IconName;
  className?: string;
}) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium',
        TONES[tone],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {icon ? <Icon name={icon} size={13} /> : null}
      {children}
    </span>
  );
}

/** 状态点 + 文字，用于链路状态、可用性这类需要一眼看出状态的场合。 */
export function StatusDot({
  label,
  tone = 'ok',
  className,
}: {
  label: string;
  tone?: 'ok' | 'warn' | 'bad';
  className?: string;
}) {
  const color = tone === 'ok' ? 'bg-palette-3' : tone === 'warn' ? 'bg-palette-4' : 'bg-palette-5';

  return (
    <span className={['inline-flex items-center gap-2 text-xs text-fg-muted', className].filter(Boolean).join(' ')}>
      <span className={`h-1.5 w-1.5 rounded-full ${color}`} aria-hidden="true" />
      {label}
    </span>
  );
}
